import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translation files
import us from "./us.json";
import al from "./al.json";

const resources = {
  us: {
    translation: us,
  },
  al: {
    translation: al,
  },
};

const savedLang = typeof window !== "undefined" && localStorage.getItem("userLang");

i18n.use(initReactI18next).init({
  resources,
  lng: savedLang || "al", // default language: Albanian (respects saved preference)
  fallbackLng: "us", // fallback language if the key is missing in the chosen language
  interpolation: {
    escapeValue: false, // React already protects from XSS
  },
});

export default i18n;
